module.exports = __webpack_public_path__ + "img/2021.8.e03ad3a9.png";